<template>
  <app-select :data-title="$t('message.generics.message.spots')"
              :data-menu-heading="$t('message.generics.message.spots')"
              data-menu-width="400px"
              :data-button-gradient="true"
              :small="small"
              @search="v => search(v)"
              @opened="onOpened"
              @hidden="emitHidden">
    <treeselect v-model="value"
                class="local-filter"
                :normalizer="normalizer"
                :options="list"
                multiple
                clearable
                always-open
                sort-value-by="INDEX"
                value-consists-of="ALL"
                :noOptionsText="$t('message.generics.message.noOptionsText')"></treeselect>

  </app-select>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import AppSelect from "@components/Select";
import filter from "@mixins/filter";

export default {
  components: {
    AppSelect,
    Treeselect,
  },

  data() {
    return {
      text: "",
      key: "local",
      list: [],
      pagination: {
        page: 0,
        amountPerPage: 50,
      },
      infiniteId: Date.now(),
      isComplete: false,
    };
  },

  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    filters() {
      return this.entity ? this.$store.state[this.entity].filters : {};
    },
    estableshimentIds() {
      return this.filters.establishments;
    },
    isEstabelecimento() {
      return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
    },
  },

  watch: {
    estableshimentIds: {
      deep: true,
      handler(val, oldVal) {
        const hasChanged = val.length !== oldVal.length;

        if (hasChanged) {
          this.reload();
        }
      },
    },
  },

  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.childrens.length ? node.childrens : undefined,
      };
    },
    emitHidden() {
      this.$emit("hidden");
    },
    async load() {
      const payload = {
        pagination: {
          page: 0,
          amountPerPage: 50,
        },
        filters: {
          search: this.text,
        },
        establishmentIds: this.estableshimentIds,
        isEstabelecimento: this.isEstabelecimento,
      };

      const locals = await this.$loader.local.load(payload);

      this.list = locals;

      this.isComplete = true;
    },
    search(search) {
      this.text = search;

      this.reload();
    },
    reload() {
      this.isComplete = false;

      this.pagination = {
        page: 0,
        amountPerPage: 50,
      };

      this.list = [];

      this.load();
    },
    onOpened() {
      this.$emit("opened");
    },
  },

  beforeDestroy() {
    //this.reloadList();
    //this.value = []
  },

  mixins: [filter],

  mounted() {
    this.text = "";
    this.load();
  },
};
</script>

<style scoped>
</style>
